import React, { useEffect, useState } from 'react'
import { observable } from 'mobx'
import { task } from 'mobx-task'

import { menuInfo } from '../../controls/LayoutPreview'

import { ExportType } from '../../controls/preview-report/hooks/useTableCompareAssessmentReport'

import useOverviewPreviewReport from '../../controls/preview-report/hooks/useOverviewPreviewReport'
import { CustomRouteProps } from '../../routers/router'
import useStore from '../../stores/useStore'
import { observer } from 'mobx-react-lite'
import useDidMountEffect from '../../hooks/useDidMountEffect'

import apiUrl from '../../configs/apiUrl'
import { axiosGet } from '../../utils/axios'
import { ResponseOverviewDashboard } from '../../pages/overview/UserOverview'

import { convertDateToFormatTHFullMonth } from '../../utils/date'

import { useParams } from 'react-router-dom'
import OverviewFullReport from './OverviewFullReport'

type UseFullReport = {}
const useFullReport = (props: UseFullReport) => {
    const { loadingStore } = useStore()
    let { questID, commuID }: any = useParams()
    const { onOpenFullReportPdfSamePage, reportToClient, isLoadingOpenFullReportPdf } = useOverviewPreviewReport({
        fromUrl: true,
    })

    useDidMountEffect(() => {
        setTimeout(() => {
            loadingStore.setLoading(isLoadingOpenFullReportPdf)
        }, 1000)
    }, [isLoadingOpenFullReportPdf])

    const [state] = useState(
        observable({
            dataSource: [] as any[],
            getOverviewDashboard: task.resolved(async () => {
                let endpoint = apiUrl.getFullPreviewReportAdmin
                    .replace('{{commID}}', commuID)
                    .replace('{{questID}}', questID)

                const { request } = axiosGet<ResponseOverviewDashboard>({
                    url: endpoint,
                    authorizationType: 'authorization',
                })
                const { data } = await request
                state.dataSource = [
                    //replace allData with data from api
                    {
                        ...data,
                        questionnaireName: `${data.questionnaireName} ประจำปี ${data.questionnaireYear + 543}`,
                        questionnaireRef: React.createRef<HTMLElement>(),
                        //@ts-ignore
                        dimensions: reportToClient(data.dimensions, data.questionnaireScore),
                        date: `วันที่ ${convertDateToFormatTHFullMonth(Date())}`,
                    },
                ]
            }),
        }),
    )

    useEffect(() => {
        ;(async () => {
            await state.getOverviewDashboard()
            if (state.dataSource[0].admin) {
                loadingStore.setLoading(true)
                setTimeout(() => {
                    onOpenFullReportPdfSamePage({ data: state.dataSource })
                }, 2000)
            }
        })()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const onClickMenu = async (value: menuInfo) => {
        switch (value.key) {
            case ExportType.BROWSER_PDF:
                break
            default:
                break
        }
    }
    return { onClickMenu, state }
}

type FullReportViewProps = {} & ReturnType<typeof useFullReport>
let FullReportView: React.FC<FullReportViewProps> = (props) => {
    return <OverviewFullReport {...props} />
}
FullReportView = observer(FullReportView)

type FullReportProps = {} & CustomRouteProps
let FullReport: React.FC<FullReportProps> = () => {
    const state = useFullReport({})
    return <FullReportView {...state} />
}
FullReport = observer(FullReport)

export default FullReport
